import React from 'react';
export default function ButterflyWingsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="10" cy="16" rx="8" ry="10" fill="#CE93D8" opacity="0.8" />
      <ellipse cx="30" cy="16" rx="8" ry="10" fill="#CE93D8" opacity="0.8" />
      <ellipse cx="10" cy="28" rx="5" ry="7" fill="#BA68C8" opacity="0.7" />
      <ellipse cx="30" cy="28" rx="5" ry="7" fill="#BA68C8" opacity="0.7" />
      <ellipse cx="10" cy="16" rx="4" ry="5" fill="#E1BEE7" opacity="0.5" />
      <ellipse cx="30" cy="16" rx="4" ry="5" fill="#E1BEE7" opacity="0.5" />
      <rect x="19" y="8" width="2" height="26" rx="1" fill="#4A148C" />
    </svg>
  );
}
